module.exports = __webpack_public_path__ + "img/bilibili-top.800eb11b.png";